<!-- eslint-disable max-lines -->
<template>
    <paper id="vehicleFreePlatform">
        <el-tabs v-model="activeName">
            <el-tab-pane label="路歌" name="first">
                <road-song></road-song>
            </el-tab-pane>
            <el-tab-pane label="G7" name="second">
                <g-seven></g-seven>
            </el-tab-pane>
            <el-tab-pane label="网货" name="third">
                <freight></freight>
            </el-tab-pane>
            <el-tab-pane label="传化" name="four">
                <transfar></transfar>
            </el-tab-pane>
        </el-tabs>
    </paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import roadSong from './roadSong/roadSong';
import paper from '@/components/core/paper/Paper';
import GSeven from './GSeven/Main';
import Freight from './freight/Main';
import Transfar from './transfar/Main';

export default {
    components: { paper, roadSong, GSeven, Freight, Transfar },
    data() {
        return {
            activeName: 'first'
        };
    },
    methods: {},
    mounted() {}
};
</script>

<style lang="less">
#vehicleFreePlatform {
    padding-top: 0px;
    .g-seven-list, .vehicleFreePlatformList, .online-cargo, .transfar {
        #mPane3 {
            .otp-table {
                .el-table {
                    min-height: calc(100vh - 185px);
                    max-height: calc(100vh - 185px);
                }
            }
        }
    }
}
</style>
